export enum Breakpoints {
    Phone = 480,
    SmallTablet = 600,
    Tablet = 768,
    LargeTablet = 810,
    Laptop = 940,
    LargeLaptop = 980,
    SmallDesktop = 1024,
    Desktop = 1180,
    LargeDesktop = 1408,
    WideDesktop = 1664,
}
